import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { supabase, isSupabaseConfigured } from "./lib/supabase";
import { ErrorBoundary } from "./components/error/ErrorBoundary";

// Expose supabase client for debugging
if (import.meta.env.DEV) {
  (window as any).supabase = supabase;
  console.log(
    isSupabaseConfigured
      ? "✅ Supabase configured and ready"
      : "⚠️ Supabase not configured - cloud features disabled"
  );
}

// Debug logging
console.log("main.tsx loading...");
console.log("Root element:", document.getElementById("root"));

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("❌ Root element not found!");
  throw new Error("Root element not found");
}

console.log("✅ Creating React root...");
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
console.log("✅ React app rendered!");
